import { define } from '../../define.js';
import { Tooltip } from './tooltip.js';
export * from './tooltip.js';
define('tooltip', Tooltip);
